import { render } from "./DisabledOption.vue?vue&type=template&id=241d5787"
import script from "./DisabledOption.vue?vue&type=script&lang=ts"
export * from "./DisabledOption.vue?vue&type=script&lang=ts"
script.render = render

export default script